import React from 'react';
import { Grid, Skeleton, Stack } from '@mui/material';

function FilterLoadingSkeleton(count,heightValue = 40) {
  // as per the count filter skeleton will be created
  const skeletonCount = new Array(count || 1).fill(0);
  return (
    <Grid container spacing={1} mt={1}>
      {skeletonCount.map((e) => (
        <Grid key={e} item md={3}>
          <Stack spacing={1}>
            <Skeleton
              animation='wave'
              variant='rectangular'
              width='100%'
              height={heightValue}
            />
          </Stack>
        </Grid>
      ))}
    </Grid>
  );
}

export default FilterLoadingSkeleton;
